import Experiment from '@mc/experiments-react'
import { useTranslation } from '@mc/i18n'
import { useStaticData } from '@mc/static-data-react'
import { EventTypes, PageSource } from '@mc/track-event'
import BusinessBanner from 'components/BusinessBanner'
import { ClassSampleEmailCapture } from 'components/EmailCapture'
import { FAQ } from 'components/FAQ'
import { JumpNav } from 'components/JumpNav'
import { RelatedCoursesCarousel } from 'components/RelatedCoursesCarousel'
import { Subscription } from 'components/Subscription'
import { DroppableQuizModuleExperiment } from 'experiments/pen-4558_v1-droppable-quiz-module'
import {
  CONTEST_PROMO_TILE_FLAG,
  ContestPromoTile,
  useContestPromoExp,
} from 'experiments/pen-5236_v2_contest_promo_tile'
import { ClassSpecialTypes } from '../../classSpecialType'
import Details from '../Details'
import RelatedArticles from '../RelatedArticles'
import { SubcatCoursesSection } from '../SubcatCoursesSection'

const PAGE_SOURCE = PageSource.LOGGED_OUT_CLASS

const BelowTheFold = () => {
  const { t } = useTranslation('@mc/next')
  const {
    course,
    relatedCourses,
    primaryGrowthCatAndSubcat,
    classSpecialType,
  } = useStaticData()

  const { showContestExperiment, contestPromoProps } = useContestPromoExp(
    course.slug,
  )

  const jumpNavItems = [
    {
      copy:
        classSpecialType === ClassSpecialTypes.DOCUMENTARY
          ? t('documentary.navigation.details')
          : t('course.navigation.details'),
      anchor: 'details',
    },
    {
      copy: t('course.navigation.related'),
      anchor: 'category-classes',
    },
    { copy: t('course.navigation.faq'), anchor: 'faq' },
  ]

  return (
    <>
      <JumpNav slug={course.slug} items={jumpNavItems} className='mc-mt-10' />

      <Details
        key={course.slug}
        className='container mc-mst-12 mc-py-10'
        id='details'
      />

      {showContestExperiment && (
        <Experiment
          name={CONTEST_PROMO_TILE_FLAG}
          variant_1={() => (
            <ContestPromoTile
              contestPromoProps={contestPromoProps}
              pageSource={PAGE_SOURCE}
            />
          )}
        />
      )}

      <Subscription />
      <DroppableQuizModuleExperiment />
      <SubcatCoursesSection />

      <RelatedCoursesCarousel
        className='container mc-py-10'
        courses={relatedCourses}
        id='related-classes'
        title={
          classSpecialType === ClassSpecialTypes.DOCUMENTARY
            ? t('documentary.relatedCourses.similar.title')
            : t('course.relatedCourses.similar.title')
        }
      />

      <ClassSampleEmailCapture
        trackProps={{
          location: 'class_page_body_slim_banner',
          contentType: 'courses',
          slug: course.slug,
        }}
        preSelectedCategorySlug={
          primaryGrowthCatAndSubcat?.primaryCategory?.slug
        }
        categoryEmailCaptureClass='mc-mt-9'
      />
      <BusinessBanner pageSource={PAGE_SOURCE} />
      <FAQ
        id='faq'
        className='container mc-mst-12 mc-py-10'
        eventType={EventTypes.COURSE_MARKETING_CLICK}
        eventLocation='class-page-body-faq'
        sections={['bogo', 'promo', 'general', 'pricing', 'sessions']}
      />
      <RelatedArticles />
    </>
  )
}

export default BelowTheFold
